// extracted by mini-css-extract-plugin
export default {"root":"SignUp_root__twSWu","logo":"SignUp_logo__rMhEJ","signupForm":"SignUp_signupForm__Rsb7a","title":"SignUp_title__bVPcS","error":"SignUp_error__EdHEC"};